import React, { useEffect, useState } from 'react'

const ClicktoEditInput = ({ placeholder, handleChange }) => {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(placeholder);
    const handleSave = () => {
        handleChange(value);
        setEditing(false);
    }
    const actionButtonWrapper = {
        position: "absolute",
        right: "10px",
        display: "flex",
        alignItems: "center",
        height: "100%",
        bottom: "10%"
    }
  return (
    <>
        {
            !editing ?
            <span role="button" style={{display: "flex"}} onClick={() => setEditing(true)}>
                {placeholder}
                <span role='button' style={{display: 'flex', height: "18px", width: "18px"}} title='Edit'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2">
                        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                    </svg>
                </span>
                
            </span> :
            <div style={{position: "relative", display: "flex"}}>
                <input type='text' value={value} onChange={(e) => setValue(e.currentTarget.value)} className='form-control'/>
                <div className='action-btn-wrapper' style={actionButtonWrapper}>
                    <span role='button' onClick={() => setEditing(false)} style={{display: 'flex', height: "18px", width: "18px"}} title='Cancel'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </span>
                    <span role='button' onClick={handleSave} style={{display: 'flex', height: "18px", width: "18px"}} title='Save'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </span>
                </div>
                
            </div>

        }
    </>
    
  )
}

export default ClicktoEditInput